// extracted by mini-css-extract-plugin
export default {"overlay":"Mx-z","bodyOpen":"Nx-z","content":"Ox-z","header":"Px-z","close":"Qx-z","closeNoHeading":"Rx-z"};